import {gql} from "@irati/utils/gql"

const fragment = gql`
  fragment CelebrationTag on CelebrationTag {
    uuid
    name
    label
    isComingSoon
    automationType
    settings {
      rewardType
    }
    cover {
      alt
      href
    }
    image {
      alt
      href
    }
    icon {
      alt
      href
    }
  }
`

export default fragment
